export interface IStateSettings {
	/** The two-letter ISO-3166-1 Alpha-2 codes for the state. */
	code: string;

	/** The display name of the state */
	name: string;

	/** A list of regex validation rules specific to this state */
	validationRules: {
		type: StateRegexType;
		regex: string;
	}[];
}

export enum StateRegexType {
	Unknown = -1,
	LicenseNumber,
}
